import React from 'react';
import { Sparkles } from 'lucide-react';
export function ProductReveal() {
  return <section className="w-full bg-lavender-light/30 py-24 px-6 md:px-8" style={{
    paddingTop: '30px',
    paddingBottom: '30px'
  }} data-id="element-236">
      <div className="max-w-4xl mx-auto text-center" data-id="element-237">
        <div className="inline-flex items-center justify-center p-3 bg-white rounded-full shadow-sm mb-6" data-id="element-238">
          <Sparkles className="w-6 h-6 text-lavender-dark" data-id="element-239" />
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-text mb-6" style={{
        fontSize: '32px'
      }} data-id="element-240">
          Presento: Plan de Supervivencia Postparto (0–30 días)
        </h2>

        <div className="max-w-2xl mx-auto space-y-6 text-lg md:text-xl text-text/80" data-id="element-241">
          <p data-id="element-242">
            Un PDF ultra-práctico que te dice qué hacer día por día durante tu
            primer mes, cuando estás cansada, sensible y sin ganas de
            improvisar.
          </p>

          <p className="text-2xl font-serif text-text font-medium pt-4" data-id="element-243">
            No te promete "un posparto hermoso".
            <br data-id="element-244" />
            <span className="text-lavender-dark font-bold" data-id="element-245">
              Te promete algo mejor: un plan para hoy.
            </span>
          </p>
        </div>
      </div>
    </section>;
}